import { useEffect, useState } from "react";
import { getObsessedRightNow } from "../services/ObsessedRightNow.service";

export const useObsessedRightNow = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchObsessed = async () => {
      const banners = await getObsessedRightNow();

      const mappedData = banners
        .slice()
        .sort((a, b) => a.sequence - b.sequence)
        .map((item) => ({
          id: item.id,
          src: item.media,
          title: item.name || "",
          url: item.action_url,
        }));

      setItems(mappedData);
      setLoading(false);
    };

    fetchObsessed();
  }, []);

  return { items, loading };
};